import { IState } from "./state";
import { ActionTree, Store, ActionContext } from "vuex";
import * as api from "../api";

type PayloadType =
  | "initApp"
  | "setState"
  | "showMore"
  | "setQuery"
  | "makeSearch"
  | "toggleFilter"
  | "deselectAllFilters"
  | "searchSuggestion";
export type ActionPayload<ActionData> = {
  type: PayloadType;
  payload: ActionData;
};
export type FilterGroup = "areaFilter" | "statusFilter";
export interface IToggleFilterPayload {
  group?: FilterGroup;
  id: string;
  value: boolean;
}

type ActionHandler<ActionData> = (
  this: Store<IState>,
  injectee: ActionContext<IState, IState>,
  payload: ActionPayload<ActionData>
) => any;
type ActionCreator<ActionData> = (
  data: ActionData
) => ActionPayload<ActionData>;

// Action creators
export const initApp: ActionCreator<IState> = (state) => ({
  type: "initApp",
  payload: state,
});
export const showMore: ActionCreator<undefined> = (undefined) => ({
  type: "showMore",
  payload: undefined,
});
export const makeSearch: ActionCreator<undefined> = (undefined) => ({
  type: "makeSearch",
  payload: undefined,
});
export const setQuery: ActionCreator<string> = (query) => ({
  type: "setQuery",
  payload: query,
});
export const toggleFilter: ActionCreator<IToggleFilterPayload> = (payload) => ({
  type: "toggleFilter",
  payload: payload,
});
export const deselectAllFilters: ActionCreator<undefined> = (payload) => ({
  type: "deselectAllFilters",
  payload: payload,
});
export const searchSuggestion: ActionCreator<string> = (payload) => ({
  type: "searchSuggestion",
  payload: payload,
});

// Action handlers
const searchSuggestionAction: ActionHandler<string> = (
  { commit, state, dispatch },
  { payload }
) => {
  commit({
    type: "setQuery",
    payload: payload,
  });
  dispatch({
    type: "makeSearch",
    payload: undefined,
  });
};
const deselectAllFiltersAction: ActionHandler<undefined> = (
  { commit, state },
  { payload }
) => {
  commit({
    type: "deselectAllFilters",
    payload,
  });
};
const toggleFilterAction: ActionHandler<IToggleFilterPayload> = (
  { commit, state },
  { payload }
) => {
  commit({
    type: "toggleFilter",
    payload,
  });
  commit({
    type: "setPage",
    payload: 0,
  });
};
const setQueryAction: ActionHandler<string> = ({ commit }, { payload }) => {
  commit({
    type: "setQuery",
    payload,
  });
};
const makeSearchAction: ActionHandler<undefined> = (
  { commit, state },
  { payload }
) => {
  api
    .search(state.endpoints.searchURL, {
      page: 0,
      query: state.query,
    })
    .then((res) => {
      commit({
        type: "newSearch",
        payload: res,
      });
      commit({
        type: "setSearchedQuery",
        payload: undefined,
      });
      commit({
        type: "setSuggestion",
        payload: res.suggestion,
      });
    });
};
const showMoreAction: ActionHandler<undefined> = (
  { commit, state },
  { payload }
) => {
  commit({
    type: "increasePage",
    payload: undefined,
  });
};
const initAppAction: ActionHandler<IState> = ({ commit }, { payload }) => {
  commit({
    type: "setState",
    payload,
  });
};
const actions: ActionTree<IState, IState> = {
  initApp: initAppAction,
  showMore: showMoreAction,
  makeSearch: makeSearchAction,
  setQuery: setQueryAction,
  toggleFilter: toggleFilterAction,
  deselectAllFilters: deselectAllFiltersAction,
  searchSuggestion: searchSuggestionAction,
};

export default actions;
